import React from "react";
import _ from "lodash";
import { Popover } from "@toddle-edu/ds-web";
import TranscriptStudentsList from "TranscriptsV3/components/StudentsPopover/components/TranscriptStudentsList/TranscriptStudentsList";

const styles = {
  popoverContainerStyles: {
    zIndex: 1000,
  },
};

export const getCustomGridHeaders = ({
  includeInGpaLabel,
  nameLabel,
  shouldShowIncludeInGpa,
  usedInTranscriptsLabel,
  GPA_COL_WIDTH = 139,
  ASSOCIATION_COL_WIDTH = 170,
  REORDER_COL_WIDTH = 104,
  DELETE_COL_WIDTH = 44,
}) => [
  { id: "name", title: nameLabel, flex: 1, columnKey: "name" },
  ...(shouldShowIncludeInGpa
    ? [
        {
          id: "gpa",
          title: includeInGpaLabel,
          width: GPA_COL_WIDTH,
          columnKey: "gpa",
        },
      ]
    : []),
  {
    id: "association",
    title: usedInTranscriptsLabel,
    width: ASSOCIATION_COL_WIDTH,
    columnKey: "association",
  },
  { id: "reorder", title: "", width: REORDER_COL_WIDTH, columnKey: "reorder" },
  { id: "delete", title: "", width: DELETE_COL_WIDTH, columnKey: "delete" },
];

export const getCustomGridData = ({
  associationEntityCollectionKey,
  emptyRow,
  emptyRowIncludeInGpa,
  errorText,
  deleteTooltipText,
  onDelete,
  onRowsReorder,
  placeholder,
  rows,
  shouldShowIncludeInGpa,
  t,
  valueKey,
}) => {
  const existingRows = _.map(rows, (item, index) => {
    const count = _.get(item, "associations.totalCount", 0);
    const deleteDisabled = count > 0;
    const isFirst = index === 0;
    const isLast = index === rows.length - 1;

    const handleMoveUp = () => {
      onRowsReorder?.(index, index - 1);
    };
    const handleMoveDown = () => {
      onRowsReorder?.(index, index + 1);
    };
    const handleDelete = () => onDelete?.(item.id);

    return {
      rowId: item.id,
      columns: [
        {
          value: item[valueKey] || "",
          cellType: "text",
          isEditable: true,
          hasError: Boolean(item.hasError),
          error: item.hasError ? errorText || " " : null,
          placeholder,
          colId: "name",
        },
        ...(shouldShowIncludeInGpa
          ? [
              {
                value: Boolean(item.includeInGpa),
                cellType: "toggle",
                isEditable: true,
                colId: "gpa",
              },
            ]
          : []),
        {
          value: t("common:student_count", { count }),
          cellType: "label",
          isEditable: false,
          styles: {
            title: {
              color: count > 0 ? "#008392" : "#ADADAD",
              fontWeight: 600,
            },
          },
          ...(count > 0
            ? {
                popover: (
                  <Popover
                    bodyPadding={[0, 0, 0, 0]}
                    title=""
                    containerStyle={{ ...styles.popoverContainerStyles }}
                    shouldCloseOnEscape
                    isClosable={false}
                    placement="left"
                    body={
                      <TranscriptStudentsList
                        count={count}
                        entityCollectionKey={associationEntityCollectionKey}
                        entityId={item.id}
                      />
                    }
                  />
                ),
              }
            : {}),
        },
        {
          cellType: "icon",
          value: [
            {
              name: "UpArrowOutlined",
              isDisabled: isFirst,
              onIconClick: isFirst ? () => {} : handleMoveUp,
            },
            {
              name: "DownArrowOutlined",
              isDisabled: isLast,
              onIconClick: isLast ? () => {} : handleMoveDown,
            },
          ],
          colId: "reorder",
        },
        {
          cellType: "icon",
          value: "DeleteOutlined",
          isDisabled: deleteDisabled,
          onIconClick: deleteDisabled ? () => {} : handleDelete,
          tooltip: deleteDisabled ? (
            <div
              style={{
                padding: "8px",
                color: "#fafafa",
                font: "500 12px AvenirNext",
                backgroundColor: "#1f1f1f",
                borderRadius: 4,
                maxWidth: 312,
                wordWrap: "break-word",
              }}
            >
              {deleteTooltipText}
            </div>
          ) : null,
        },
      ],
    };
  });

  if (!emptyRow) return existingRows;

  const emptyDataRow = {
    rowId: "__empty_row__",
    columns: [
      {
        value: emptyRow.value || "",
        cellType: "text",
        isEditable: true,
        placeholder,
      },
      ...(shouldShowIncludeInGpa
        ? [
            {
              value: Boolean(emptyRowIncludeInGpa),
              cellType: "toggle",
              isEditable: false,
              isDisabled: true,
            },
          ]
        : []),
      {
        value: t("common:student_count", { count: 0 }),
        cellType: "label",
        isEditable: false,
        styles: {
          title: { color: "#ADADAD", fontWeight: 600 },
        },
      },
      {
        cellType: "icon",
        value: [
          {
            name: "UpArrowOutlined",
            isDisabled: true,
            onIconClick: () => {},
          },
          {
            name: "DownArrowOutlined",
            isDisabled: true,
            onIconClick: () => {},
          },
        ],
        colId: "reorder",
      },
      {
        cellType: "icon",
        value: "DeleteOutlined",
        isDisabled: true,
        onIconClick: () => {},
      },
    ],
  };

  return [...existingRows, emptyDataRow];
};
